import { IEnvironment } from "./environment.interface";

export const Environment: IEnvironment = {
    "target": "dev2",
    apiRoot: "https://pcpwebdev2.dev.pulte.com/",
    pcpUrl: "https://pcpwebdev2.dev.pulte.com/",
    bwpUrl: "https://bwp.dev.pulte.com/",
    bqaUrl: "https://bqa.dev.pulte.com/",
    serviceUrl: "https://pultedev.crm.dynamics.com/apps/service",
    reportingUrl: "http://powerbi.dev.pulte.com/Reports/browse/IDEA/Home%20Building%20Operations/Construction%20Operations%20Reports",
    appInsights: {
        "instrumentationKey": "d0558c6c-4295-45e4-b6a9-86a72df00614"
    },
    authConfig: {
        clientId: 'a51e7f67-67f5-4e85-8a4c-ad98d2bd979c',
        issuer: 'https://login.microsoftonline.com/1a9277a3-ef66-41f6-96b5-c5390ee468a7/v2.0',
        responseType: 'code',
        redirectUri: 'https://pcpwebdev2.dev.pulte.com/',
        scope: 'api://a51e7f67-67f5-4e85-8a4c-ad98d2bd979c/user_impersonation',
        clearHashAfterLogin: true,
        requestAccessToken: true,
        showDebugInformation: true,
        skipIssuerCheck: false,
        strictDiscoveryDocumentValidation: false
    },
    "googleAnalytics": {
        tagManagerUrl: "https://www.googletagmanager.com/gtag/js?id=UA-150271777-2",
        gtagScript: "window.dataLayer = window.dataLayer || []; function gtag(){ dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'UA-150271777-2');"
    },
    "whatFix": {
        scriptUrl: '//whatfix.com/1a3b4fc0-3b83-11e9-aaf4-04013d24cd02/embed/embed.nocache.js'
    },
    "storage": "e992d3bc1af0436eb5906b4293936c7a"
};
